import { useQuery } from "@tanstack/react-query";
import { QueryBuilder } from "features/members";
import { axios } from "lib/axios";

export const getAssetsPaginated = ({ churchId, page, pageSize, queries }) => {
  const queryBuilder = new QueryBuilder();

  queryBuilder.pagination(page, pageSize);

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  if (queries.filter) {
    queryBuilder.filter(queries.filter);
  }

  const queryString = queryBuilder.build();

  return axios.get(`/churches/${churchId}/assets-paginated${queryString}`);
};

export const useAssetsPaginated = ({
  churchId,
  page,
  pageSize,
  queries = {},
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["assets", page, pageSize, churchId, JSON.stringify(queries)],
    queryFn: () => getAssetsPaginated({ churchId, page, pageSize, queries })
  });
};
